module.exports = __webpack_public_path__ + "static/media/Tata.89401af6.png";